module.exports = __webpack_public_path__ + "static/img/stationery.445373d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stationery.png
// module id = y5It
// module chunks = 18